import React from 'react';
import noop from 'lodash/noop';
import Button from '../button';
import { Size } from '../core/enum';
import { ButtonColor } from '../button/enum';
export default function TransferOperation(props) {
    const { moveToLeft = noop, moveToRight = noop, leftActive, rightActive, className, multiple, } = props;
    if (multiple) {
        return (React.createElement("div", { className: className },
            React.createElement(Button, { color: ButtonColor.primary, size: Size.small, disabled: !leftActive, onClick: moveToLeft, icon: "navigate_before" }),
            React.createElement(Button, { color: ButtonColor.primary, size: Size.small, disabled: !rightActive, onClick: moveToRight, icon: "navigate_next" })));
    }
    return null;
}
